// ui/Toggle + ui/Checkbox (Design Standard v1). Toggle = an on/off setting that takes
// effect immediately; Checkbox = a choice inside a form or a row selection.
import React from 'react';
import clsx from 'clsx';
import './ds.css';

export function Toggle({ checked, onChange, label, disabled, className = '', ...rest }) {
  return (
    <label className={clsx('ds-toggle', className)}>
      <input type="checkbox" role="switch" checked={!!checked} disabled={disabled}
        onChange={(e) => onChange?.(e.target.checked, e)} {...rest} />
      <span className="ds-toggle__track" aria-hidden="true" />
      {label ? <span>{label}</span> : null}
    </label>
  );
}

export function Checkbox({ checked, onChange, label, className = '', ...rest }) {
  return (
    <label className={clsx('ds-check', className)}>
      <input type="checkbox" checked={!!checked} onChange={(e) => onChange?.(e.target.checked, e)} {...rest} />
      {label ? <span>{label}</span> : null}
    </label>
  );
}

export default Toggle;
